import { Modal, Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { useAxios } from 'configs/requests';
import { Loading, Error } from 'components/Fetch';

interface IDeleteDeviceProps {
  deviceId: string | null;
  bulkDeleted: IDeviceListItem[];
  onClose: () => void;
}
const DeleteDevice = ({ deviceId, bulkDeleted, onClose }: IDeleteDeviceProps) => {
  const intl = useIntl();

  const [{ loading: loadingDelete, error: errorDelete }, postDelete] = useAxios<void>(
    {
      url: `/clinician-gateway/device/${deviceId || ''}`,
      method: 'DELETE'
    },
    { manual: true }
  );

  const [{ loading: loadingBulkDelete, error: errorBulkDelete }, postBulkDelete] = useAxios<void>(
    {
      url: '/clinician-gateway/device',
      method: 'DELETE'
    },
    { manual: true }
  );

  const getModalBody = () => {
    if (deviceId || bulkDeleted.length === 1)
      return intl.formatMessage({ id: 'deviceWillBeDeletedKey' });
    else if (bulkDeleted.length > 1) {
      return intl.formatMessage(
        {
          id: 'devicesWillBeDeletedKey'
        },
        {
          numDeleted: bulkDeleted.length
        }
      );
    }
  };

  const handleAction = () => {
    if (deviceId) handleDelete();
    else if (bulkDeleted.length > 0) handleBulkDelete();
  };

  const handleDelete = () => {
    postDelete().then(() => {
      onClose();
    });
  };

  const handleBulkDelete = () => {
    const data = {
      deviceIds: bulkDeleted.map((device) => device.deviceId)
    };
    postBulkDelete({ data }).then(() => {
      onClose();
    });
  };

  return (
    <Modal show onHide={onClose} data-test="delete-modal">
      {(errorDelete || errorBulkDelete) && <Error className="m-5" />}
      {loadingDelete || loadingBulkDelete ? (
        <Loading className="m-5" />
      ) : (
        <>
          <Modal.Header closeButton>
            <Modal.Title>{intl.formatMessage({ id: 'confirmDeleteKey' })}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{getModalBody()}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onClose} data-test="delete-cancel">
              {intl.formatMessage({ id: 'Cancel' })}
            </Button>
            <Button variant="primary" onClick={handleAction} data-test="delete-confirm">
              {intl.formatMessage({ id: 'deleteKey' })}
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default DeleteDevice;
